Object.defineProperty(Array.prototype, "pushOrReplace", {
  value: function(val: any, compFn: Function) {
    const res = [...this];
    const i = this.findIndex((v: any) => compFn(v, val));
    if (i === -1) res.push(val);
    else res.splice(i, 1, val);
    return res;
  },
  writable: true,
  configurable: true,
});
